const getUserShoppingCartQuery = /* GraphQL */ `
  query GetUserShoppingCartShallow($webUserGuid: String = null) {
    shoppingCart: shoppingCartShallow(webUserGuid: $webUserGuid) {
      shoppingCartId
      numProducts
      skuBasesInCart
    }
  }
`

export default getUserShoppingCartQuery
